import classNames from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';
import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import { SnackbarItem, SnackbarTypes } from 'reactApp/modules/snackbar/snackbar.types';
import { SwipingDownComponent } from 'reactApp/ui/SwipingDownComponent/SwipingDownComponent';
import { CheckCircleOutline, ClockOutline, ErrorCircleIcon } from 'reactApp/ui/VKUIIcons';

import { useTimer } from '../hooks/useTimer';
import { ESnackbarTheme, Snackbar } from './Snackbar';
import styles from './SnackbarComponent.css';

export const SNACKBAR_ICONS = {
    [SnackbarTypes.success]: <CheckCircleOutline className={styles.succesIcon} />,
    [SnackbarTypes.failure]: <ErrorCircleIcon className={styles.failedIcon} />,
    [SnackbarTypes.time]: <ClockOutline />,
    [SnackbarTypes.warning]: <ErrorCircleIcon />,
}

export const SnackbarComponent = (props: SnackbarItem) => {
    const { id, closable, closeTimeout, type = '' } = props;
    const { isVisible, handleClose } = useTimer({ id, closable, closeTimeout });

    const isPhone = useSelector(EnvironmentSelectors.isPhone);

    return (
        <SwipingDownComponent onClose={handleClose} lock={!isPhone && closable}>
            <div className={classNames(styles.root, { [styles[`root_stretched`]]: isPhone })}> 
                <Snackbar 
                    {...props} 
                    key={id}
                    onClose={handleClose} 
                    icon={SNACKBAR_ICONS[type]}
                    closable={!isPhone && closable}
                    stretched={isPhone}
                    visible={isVisible}
                    theme={isPhone ? ESnackbarTheme.REGULAR : ESnackbarTheme.COMPACT}
                />
            </div>
        </SwipingDownComponent>
    )
}